import { useEffect } from "react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { supabase } from "./lib/supabase";

function AuthHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    // ── Hash-based redirects on initial load ──────────────────────────────
    // Supabase email confirmation/reset links land on the site root with a
    // fragment like /#access_token=...&type=signup. Detect this and forward
    // to the correct page so its own handler can pick it up.
    const hash = window.location.hash;
    const path = window.location.pathname;
    const isRoot = path === '/' || path === '' || path.endsWith('/') && path.length <= 2;

    if (isRoot && hash.includes('access_token')) {
      if (hash.includes('type=signup') || hash.includes('type=email_change')) {
        // Email confirmation — send to login so it can show the confirmed banner
        navigate('/login' + hash, { replace: true });
        return;
      }
      if (hash.includes('type=recovery')) {
        // Password reset — send to reset-password page
        navigate('/reset-password' + hash, { replace: true });
        return;
      }
    }

    // ── Auth state listener ───────────────────────────────────────────────
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        navigate('/reset-password');
      }
    });
    return () => subscription.unsubscribe();
  }, [navigate]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthHandler />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
